"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
require("./tooltip.css");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_dom_1 = require("react-dom");
var react_popper_1 = require("react-popper");
var uuid_1 = require("uuid"); /* v4 generates a random id */
var Info_1 = require("@nbc-design/icons/lib/web/Info");
var InfoFill_1 = require("@nbc-design/icons/lib/web/InfoFill");
var tokens_json_1 = tslib_1.__importDefault(require("@nbc-design/tokens/dist/styles/tokens.json"));
/** The tooltip is activated by keyboard or mousehover and displays a contextual, non-critical information. */
var Tooltip = function (_a) {
    var content = _a.content, _b = _a.position, position = _b === void 0 ? 'auto' : _b, children = _a.children, className = _a.className, _c = _a.id, id = _c === void 0 ? (0, uuid_1.v4)() : _c, _d = _a.dataTest, dataTest = _d === void 0 ? 'tooltip' : _d, onShowTooltip = _a.onShowTooltip, onHideTooltip = _a.onHideTooltip, onHover = _a.onHover, onLeave = _a.onLeave, iIcon = _a.iIcon, _e = _a.trigger, trigger = _e === void 0 ? {
        onClick: true,
        onMouseOver: true,
        onFocus: true,
    } : _e, _f = _a.isOpened, isOpened = _f === void 0 ? false : _f, _g = _a.isPortal, isPortal = _g === void 0 ? false : _g;
    var _h = React.useState('info'), iconName = _h[0], setIconName = _h[1];
    var _j = React.useState(false), displayTooltip = _j[0], setDisplayTooltip = _j[1];
    var _k = React.useState(null), referenceElement = _k[0], setReferenceElement = _k[1];
    var _l = React.useState(null), popperElement = _l[0], setPopperElement = _l[1];
    var _m = React.useState(null), arrowElement = _m[0], setArrowElement = _m[1];
    var _o = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        modifiers: [
            {
                name: 'arrow',
                options: {
                    element: arrowElement,
                    padding: parseInt(tokens_json_1.default['s-xsmall'], 10),
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, parseInt(tokens_json_1.default['s-normal'], 10)],
                },
            },
        ],
        placement: position,
    }), styles = _o.styles, attributes = _o.attributes;
    var hideTooltip = React.useCallback(function (event) {
        if (onLeave && (event === null || event === void 0 ? void 0 : event.type) === 'mouseleave')
            onLeave();
        if (onHideTooltip)
            onHideTooltip();
        setIconName('info');
        setDisplayTooltip(false);
    }, [onHideTooltip, onLeave]);
    var showTooltip = React.useCallback(function (event) {
        if (onHover && (event === null || event === void 0 ? void 0 : event.type) === 'mouseover')
            onHover();
        if (onShowTooltip)
            onShowTooltip();
        setIconName('info-fill');
        setDisplayTooltip(true);
    }, [onHover, onShowTooltip]);
    React.useEffect(function () {
        isOpened ? showTooltip() : hideTooltip();
    }, [hideTooltip, isOpened, showTooltip]);
    var classes = (0, classnames_1.default)('dsc-tooltip', !children && 'has-iIcon', className);
    var handleEscape = React.useCallback(function (event) {
        var key = event.key;
        var activeElement = document === null || document === void 0 ? void 0 : document.activeElement;
        if (key === 'Escape') {
            hideTooltip();
            // add a delay so we can avoid the modal to close if the tooltip is open
            setTimeout(function () {
                activeElement === null || activeElement === void 0 ? void 0 : activeElement.blur();
            }, 10);
        }
    }, [hideTooltip]);
    var iconProps = {
        className: 'dsc-tooltip__iIcon',
        size: (iIcon === null || iIcon === void 0 ? void 0 : iIcon.size) || 'medium',
    };
    var childrenMarkup = children || ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "dsc-tooltip__btn", "aria-label": iIcon === null || iIcon === void 0 ? void 0 : iIcon.title, children: iconName === 'info' ? (0, jsx_runtime_1.jsx)(Info_1.Info, tslib_1.__assign({}, iconProps)) : (0, jsx_runtime_1.jsx)(InfoFill_1.InfoFill, tslib_1.__assign({}, iconProps)) }));
    var addAriaToChildren = function (markup) {
        var ariaProps = {
            'aria-describedby': displayTooltip ? "".concat(id, "__tooltip-bubble") : undefined,
        };
        return React.cloneElement(markup, ariaProps);
    };
    var tootipMarkup = displayTooltip && ((0, jsx_runtime_1.jsxs)("div", tslib_1.__assign({ ref: setPopperElement, style: styles.popper, className: "dsc-tooltip__bubble", role: "tooltip", id: "".concat(id, "__tooltip-bubble") }, attributes.popper, { children: [(0, jsx_runtime_1.jsx)("span", { className: "dsc-tooltip__content", "data-test": "content", children: content }), (0, jsx_runtime_1.jsx)("div", { ref: setArrowElement, style: styles.arrow, className: "dsc-tooltip__arrow" })] })));
    return ((0, jsx_runtime_1.jsxs)("span", tslib_1.__assign({ className: classes }, (trigger.onMouseOver && {
        onMouseLeave: function (event) {
            hideTooltip(event);
        },
    }), { "data-test": dataTest, children: [(0, jsx_runtime_1.jsx)("span", tslib_1.__assign({ className: "dsc-tooltip__trigger" }, (trigger.onMouseOver && {
                onMouseEnter: function (event) {
                    showTooltip(event);
                },
            }), (trigger.onFocus && {
                onFocus: showTooltip,
            }), (trigger.onClick && {
                onClick: showTooltip,
            }), { onBlur: hideTooltip }, (trigger.onClick && {
                onKeyDown: handleEscape,
            }), { id: "".concat(id, "__trigger"), "data-test": "trigger", ref: setReferenceElement, children: addAriaToChildren(childrenMarkup) })), isPortal ? (0, react_dom_1.createPortal)(tootipMarkup, document.body) : tootipMarkup] })));
};
exports.Tooltip = Tooltip;
exports.Tooltip.displayName = 'Tooltip';
//# sourceMappingURL=tooltip.js.map